var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSendOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.4168V4.58342C2.5 4.27786 2.625 4.04509 2.875 3.88509C3.125 3.72564 3.38889 3.70148 3.66667 3.81259L16.5 9.22925C16.8472 9.38203 17.0208 9.63898 17.0208 10.0001C17.0208 10.3612 16.8472 10.6181 16.5 10.7709L3.66667 16.1876C3.38889 16.2987 3.125 16.2743 2.875 16.1143C2.625 15.9548 2.5 15.7223 2.5 15.4168ZM4.16667 14.1668L14.0417 10.0001L4.16667 5.83342V8.75009L9.16667 10.0001L4.16667 11.2501V14.1668ZM4.16667 10.0001V5.83342V14.1668V10.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSendOutline);
export default __webpack_public_path__ + "static/media/ico-send-outline.e9037afd8d49666fc6d6bf8c46cb02d7.svg";
export { ForwardRef as ReactComponent };